const { REACT_APP_ASSIST_API_URL, REACT_APP_ASSIST_API_TOKEN } = process.env;

const decryptPhoneNumberApi = () => {
  return {
    headers: {
      username: "p90meg",
      emquest_access_token: REACT_APP_ASSIST_API_TOKEN,
    },
    apiUrl: REACT_APP_ASSIST_API_URL + `/system/decrypt`,
  };
};

export default decryptPhoneNumberApi;
